import axios from 'axios';
import moment from 'moment';
import router from '../Router';
import { get as getCookie } from 'es-cookie';

const logout = () => {
  localStorage.removeItem('at_access_token');
  let newLocation = `${appConfig.myAccountUrl}/login`;
  newLocation += `?logout=true&redirect=${encodeURIComponent(window.location.href)}`;
  window.location.href = newLocation;

  // window.location.href = '/login';

};

export default {
  LOAD_API_DATA: ({ commit, state }, args) => {
    let payload = {}; //access_token: localStorage.getItem('access_token') };

    if (args.post_data) {
      payload = Object.assign(payload, args.post_data);
    }

    if (args.init) {
      state.page = args.init;
    } else {
      state.page = {};
    }

    // THIS REALLY NEEDS TO BE IMPROVED... SORRY
    if (args.method && args.method.toLowerCase() === 'get') {
      axios.get(args.url, { params: payload })
        .then((res) => {
          if (res.data.message === 'failure') {
            if (res.data.redirect === '404') {
              router.push('/404');
            }
          }

          if (args.context && args.context.loading) {
            args.context.loading = false;
          }

          commit('SET_API_DATA', { data: res.data });
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            logout();
          }

          if (args.context && args.context.loading) {
            args.context.loading = false;
          }
        });
    } else {
      axios.post(args.url, payload)
        .then((res) => {
          if (res.data.message === 'failure') {
            if (res.data.redirect === '404') {
              router.push('/404');
            }
          }

          if (args.context && args.context.loading) {
            args.context.loading = false;
          }

          commit('SET_API_DATA', { data: res.data });
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            logout();
          }

          if (args.context && args.context.loading) {
            args.context.loading = false;
          }
        });
    }
  },

  ADVENTURE_TRAVEL_DATA: ({ commit, state }, args) => {
    let config = {
      headers: {},
    };

    if (args.bearerToken) {
      config.headers['Authorization'] = 'Bearer ' + args.bearerToken;
    }

    if (args.init) {
      state.page = args.init;
    } else {
      state.page = {};
    }

    axios.get(args.url, config)
      .then((res) => {
        if (res.data.message === 'failure') {
          if (res.data.redirect === '404') {
            router.push('/404');
          }
        }

        if (args.context && args.context.loading) {
          args.context.loading = false;
        }

        commit('SET_API_DATA', { data: res.data });
      })
      .catch((err) => {
        if (args.context && args.context.loading) {
          args.context.loading = false;
        }
      });
  },

  UPDATE_CART: ({ commit, state }, payload) => {
    let _url = appConfig.serverUrl + '/api/v1/cart';

    axios.post(_url, payload)
      .then((res) => {
        if (res.data.message === 'success') {
          commit('SET_CART', res.data.cart);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          logout();
        }
      });
  },

  GET_CART: ({ commit, state }) => {
    let _url = appConfig.serverUrl + '/api/v1/cart';

    axios.get(_url)
      .then((res) => {
        commit('SET_CART', res.data.cart);
      });
  },

  GET_USER: ({ commit }) => {
    let url = appConfig.accountUrl + '/api/v1';

    axios.get(url)
      .then((res) => {
        commit('SET_USER', { data: res.data });
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          logout();
        }
      });
  },

  UPDATE_NOTIFICATIONS: ({ commit, state }) => {
    axios.get(appConfig.serverUrl + '/api/v1/notifications')
      .then((res) => {
        commit('SET_NOTIFICATIONS', { data: res.data });
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          logout();
        }
      });
  },

  LOAD_NEXT_PAGE: ({ commit }, args) => {
    commit('SET_NEXT_PAGE', { args });
  },

  RESET_DATA: ({ commit }, args) => {
    axios.post(args.url)
      .then((res) => {
        commit('SET_RESET_DATA', { data: res.data, args });
      });
  },

  GET_SIDEBAR: ({ commit }, context) => {
    let jobsUrl = appConfig.serverUrl + '/api/v1/jobs-json';
    let tiaUrl = appConfig.serverUrl + '/api/v1/this-is-adventure/6';
    let lensUrl = appConfig.serverUrl + '/api/v1/at-photo-video';
    let jalertUrl = appConfig.serverUrl + '/api/v1/journalist-alert';
    let timeout;
    let accessToken = getCookie('atta_token');
    let now = moment();
    let cached = false;
    let cachedTime = context.$store.state.sidebar.lastUpdate;

    if (cachedTime) {
      if (now.isBefore(cachedTime)) {
        return;
      }
    }

    // Get J Alerts
    if (context.$store.state.user && context.$store.state.user.membership === 'Business') {
      axios.get(jalertUrl)
        .then((res) => {
          let key = 'jalert';

          commit('SET_SIDEBAR', { data: res.data.page.alerts, key });
        });
    }

    // Get Jobs
    // axios.get(jobsUrl, { access_token: accessToken })
    //   .then((res) => {
    //     let key = 'jobs';

    //     commit('SET_SIDEBAR', { data: res.data, key });
    //   });

    // Get ThisIsAdventure
    axios.get(tiaUrl, { access_token: accessToken })
      .then((res) => {
        let key = 'tia';

        commit('SET_SIDEBAR', { data: res.data, key });
      });

    // Get A.T the lens
    axios.get(lensUrl, { access_token: accessToken })
      .then((res) => {
        let key = 'lens';

        commit('SET_SIDEBAR', { data: res.data.data, key });
      });

    timeout = now.add(1, 'h');
    commit('SET_SIDEBAR_CACHE', { data: timeout });
  },

  LOAD_CONTEXT: ({ commit }) => {
    const url = appConfig.serverUrl + '/api/v1/context';

    if (!getCookie('atta_token')) {
      return;
    }

    axios.get(url)
      .then((res) => {
        commit('SET_CONTEXT', { data: res.data });

        // Get A.T token
        if (res.data.adventure_travel === null || res.data.adventure_travel === '') {
          axios.get(appConfig.accountUrl + '/api/v1/adventure-travel')
            .then((res) => {
              if (res && res.data && res.data.token) {
                localStorage.setItem('at_access_token', res.data.token);
              }
            })
            .catch((err) => {
              console.log(err.response);
            });
        } else {
          localStorage.setItem('at_access_token', res.data.adventure_travel);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          // Logout
          logout();
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/js/store/actions.js